// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import InvestingMenuTemplate from '../../TradingPlatformTemplates/InvestingMenuTemplate.html';
import { HtmlScroll } from '@components/webdesktop/elements/Scroll/HtmlScroll';
import Ractive from 'ractive';
export const closeContextMenuEvent = new CustomEvent();
let openContextMenuHandler = (x, y, items, addParamsObj) => { };
let hideContextMenuHandler = () => { };
let updateContextMenuHandler = (newItems) => { };
export const openContextMenu = (x, y, items, addParamsObj) => {
    openContextMenuHandler(x, y, items, addParamsObj);
};
export const hideContextMenu = () => {
    hideContextMenuHandler();
};
export const updateContextMenu = (newItems) => {
    updateContextMenuHandler(newItems);
};
export class InvestingMenu extends Ractive {
    constructor() {
        super(...arguments);
        this.functionClose = null;
    }
    getType() {
        return 'InvestingMenu';
    }
    oninit() { }
    oncomplete() {
        this.functionOnMouseDown = (event) => {
            this.onMouseDown(event);
        };
        hideContextMenuHandler = () => {
            this.Hide();
        };
        openContextMenuHandler = (x, y, items, addParamsObj) => {
            this.Show(x, y, items, addParamsObj);
        };
        updateContextMenuHandler = (newItems) => {
            void this.set({ itemsMenu: newItems });
        };
    }
    private_onItemClick(event, sender) {
        let needClose = true;
        if (sender.canCheck) {
            needClose = false;
        }
        const callback = sender.event;
        if (!isNullOrUndefined(callback)) {
            callback(sender);
        }
        if (needClose) {
            this.Close();
        }
    }
    Show(posX, posY, items, addParamsObj) {
        if (isNullOrUndefined(addParamsObj)) {
            addParamsObj = {};
        }
        const newWidth = addParamsObj.width ? addParamsObj.width : null;
        const isDarkStyle = addParamsObj.isDarkStyle ? addParamsObj.isDarkStyle : false;
        this.isShiftComboBox = addParamsObj.isShiftComboBox || 0;
        void this.set({
            left: posX,
            top: posY,
            width: newWidth,
            isDarkStyle,
            showContextMenu: true,
            itemsMenu: items
        });
        this.setFocus();
        const contextMenuElement = this.find('#fromContextMenu');
        this.scroll = HtmlScroll.addScroll(contextMenuElement);
    }
    Hide() {
        this.Close();
    }
    setFocus() {
        const form = document.getElementById('fromContextMenu');
        form.tabIndex = 1;
        form.focus();
        document.addEventListener('mousedown', this.functionOnMouseDown, { capture: true });
    }
    onMouseDown(event) {
        const form = document.getElementById('fromContextMenu');
        const posElement = form.getBoundingClientRect();
        const posX = posElement.x + posElement.width + InvestingMenu.SCROLL_WIDTH;
        const posY = posElement.y + posElement.height;
        const clickX = event.x > posElement.x && event.x < posX;
        const clickY = event.y > posElement.y - this.isShiftComboBox && event.y < posY;
        if (clickX && clickY) {
        }
        else {
            this.Close();
        }
    }
    Close() {
        var _a;
        document.removeEventListener('mousedown', this.functionOnMouseDown, { capture: true });
        void this.set({ showContextMenu: false });
        (_a = this.scroll) === null || _a === void 0 ? void 0 : _a.destroy();
        closeContextMenuEvent.Raise();
    }
    onteardown() {
        var _a;
        (_a = this.scroll) === null || _a === void 0 ? void 0 : _a.destroy();
        super.onteardown();
    }
}
InvestingMenu.SCROLL_WIDTH = 10;
Ractive.extendWith(InvestingMenu, {
    el: 'contextMenu',
    template: InvestingMenuTemplate,
    data: function () {
        return {
            showContextMenu: false,
            isDarkStyle: false,
            canCheck: false
        };
    }
});
